import React, { useState, useEffect } from 'react';
import Select, { SingleValue } from 'react-select';
import './paymentDashboard.css';
import PaymentTable from '../PaymentTable/PaymentTable';
import axios from 'axios';
import Popup from '../shared/Popup/UpdateBalancePopup';
import { useAuth } from '../../context/AuthContext';
interface Users {
  id: number;
  name: string;
  balance: number;
}

interface UserOption {
  value: number;
  label: string;
}

interface ErrorMsg {
  missingPaidUserId?: string;
  missingAmount?: string;
  missingTransferFrom?: string;
  missingtransferTo?: string;
  transferError?: string;
}

interface PopupProps {
  isOpen: boolean;
  isSuccess: boolean;
  message: string;
  updatedUsersStatus: { id: number; name: string; succesfullyUpdated: boolean }[];
  onClose: () => void;
}

function PaymentDashboard() {
  const { isLoggedIn } = useAuth();
  const [paidUserId, setPaidUserId] = useState<number | null>(null);
  const [paymentType, setPaymentType] = useState<string>('split');
  const [transferFromUserId, setTransferFromUserId] = useState<number | null>(null);
  const [transferToUserId, setTransferToUserIdUserId] = useState<number | null>(null);
  const [amount, setAmount] = useState<number | null>(null);
  const [selectedUsersId, setSelectedUsersId] = useState<number[]>([]);
  const [description, setDescription] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<ErrorMsg>({});
  const [userOptions, setUserOptions] = useState<UserOption[]>([]);
  const [users, setUsers] = useState<Users[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [popupProps, setPopupProps] = useState<PopupProps>({ isOpen: false, isSuccess: false, message: '', updatedUsersStatus: [], onClose: () => { } });

  useEffect(() => {
    initializeUsers();
  }, [])

  useEffect(() => {
    setErrorMsg({});
    setIsLoading(false);
  }, [paidUserId, paymentType, transferFromUserId, transferToUserId, amount]);

  const handleChange = (selectedOption: SingleValue<UserOption>) => {
    if (selectedOption) {
      setPaidUserId(selectedOption.value);
    } else {
      setPaidUserId(null);
    }
  };

  const initializeUsers = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('https://kaskas.pro/split-bill-server/users');
      const tempUserOptions = response.data.map((user: { id: number; name: string }) => ({
        value: user.id,
        label: user.name,
      }));
      setUserOptions(tempUserOptions);
      setUsers(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  const handleUpdate = async () => {
    if (paymentType === 'split') {
      handleSplitUpdate();
    } else if (paymentType === 'transfer') {
      handleTransferUpdate();
    }
  }

  const handleSplitUpdate = async () => {
    if (!paidUserId) {
      setErrorMsg({ ...errorMsg, missingPaidUserId: 'יש לבחור משתמש ששילם' });
      return;
    }
    if (!amount) {
      setErrorMsg({ ...errorMsg, missingAmount: 'יש להזין סכום' });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post('https://kaskas.pro/split-bill-server/split', {
        paidUserId,
        amount,
        selectedUsersId,
        description: description.trim(),
      });
      const data = response.data
      console.log(data);
      setUsers(data.users || []);
      setDescription('');
      setIsLoading(false);
      const isSuccess = data.updatedUsersStatus && data.updatedUsersStatus.some((user: { succesfullyUpdated: boolean }) => !user.succesfullyUpdated);
      console.log(isSuccess);
      setPopupProps({
        isOpen: true,
        isSuccess: !isSuccess,
        message: !isSuccess ? 'החלוקה בוצעה בהצלחה' : 'החלוקה נכשלה עבור חלק מהמשתמשים',
        updatedUsersStatus: data.updatedUsersStatus,
        onClose: () => setPopupProps({ ...popupProps, isOpen: false }),
      });

    } catch (error) {
      setPopupProps({ isOpen: true, isSuccess: false, message: 'העברה נכשלה', updatedUsersStatus: [], onClose: () => { setPopupProps({ ...popupProps, isOpen: false }); setIsLoading(false) } });
      console.error(error);
    }
  };

  const handleTransferUpdate = async () => {
    if (!transferFromUserId) {
      setErrorMsg({ ...errorMsg, missingTransferFrom: 'יש לבחור את שמו של המעביר' });
      return;
    }

    if (!transferToUserId) {
      setErrorMsg({ ...errorMsg, missingtransferTo: 'יש לבחור את שמו של המקבל' });
      return;
    }

    if (!amount) {
      setErrorMsg({ ...errorMsg, missingAmount: 'יש להזין סכום' });
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post('https://kaskas.pro/split-bill-server/transfer', {
        transferFromUserId,
        transferToUserId,
        amount,
      });

      setUsers(response.data.users || []);
      setIsLoading(false);
      if (response.data.success) {
        setPopupProps({ isOpen: true, isSuccess: true, message: 'העברה בוצעה בהצלחה', updatedUsersStatus: [], onClose: () => setPopupProps({ ...popupProps, isOpen: false }) });
        return;
      }

      setPopupProps({ isOpen: true, isSuccess: false, message: 'העברה נכשלה', updatedUsersStatus: [], onClose: () => { setPopupProps({ ...popupProps, isOpen: false }); setIsLoading(false) } });

    } catch (error) {
      setPopupProps({ isOpen: true, isSuccess: false, message: 'העברה נכשלה', updatedUsersStatus: [], onClose: () => { setPopupProps({ ...popupProps, isOpen: false }); setIsLoading(false) } });
      console.error(error);
    };

  }

  if (!isLoggedIn) {
    return (
      <div className='payment-inputs-container'>
        {isLoading && (
          <div className='loading-overlay'>
            <div className='loading-spinner'></div>
          </div>
        )}
        <PaymentTable users={users} setSelectedUsersId={() => {}} isReadOnly={true} />
      </div>
    );
  }

  return (
    <div className='payment-inputs-container'>
      {isLoading && (
        <div className='loading-overlay'>
          <div className='loading-spinner'></div>
        </div>
      )}
      <div className='payment-type'>
        <h2>בחירת פעולה</h2>
        <div className='payment-type-options'>
          <label>
            <input
              type='radio'
              value='split'
              checked={paymentType === 'split'}
              onChange={() => setPaymentType('split')}
            />
            חלוקה שווה
          </label>
          <label>
            <input
              type='radio'
              value='transfer'
              checked={paymentType === 'transfer'}
              onChange={() => setPaymentType('transfer')}
            />
            העברה
          </label>
        </div>

      </div>
      {paymentType === 'split' && (
        <div className='split-payment'>
          <h2>מי שילם?</h2>
          <Select
            options={userOptions}
            onChange={handleChange}
            className='react-select-container'
            classNamePrefix='react-select'
            placeholder='בחר משתמש'
          />
          {errorMsg.missingPaidUserId && (<p className='error-msg'>{errorMsg.missingPaidUserId}</p>)}
          <label>סכום הקניה</label>
          <input
            type='number'
            className='number-fields'
            placeholder=''
            value={amount || ''}
            onChange={(e) => setAmount(Number(e.target.value))}
          />
          {errorMsg.missingAmount && (<p className='error-msg'>{errorMsg.missingAmount}</p>)}
          <label>תיאור הקניה</label>
          <input
            type='text'
            className='text-field'
            placeholder='למשל: סלט'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div >
      )}
      {paymentType === 'transfer' && (
        <div className='transfer-payment'>
          <label>שם המעביר </label>
          <Select
            options={userOptions}
            onChange={(selectedOption) => setTransferFromUserId(selectedOption ? selectedOption.value : null)}
            className='react-select-container'
            classNamePrefix='react-select'
            placeholder=''
          />
          {errorMsg.missingTransferFrom && (<p className='error-msg'>{errorMsg.missingTransferFrom}</p>)}
          <label>שם המקבל </label>
          <Select
            options={userOptions}
            onChange={(selectedOption) => setTransferToUserIdUserId(selectedOption ? selectedOption.value : null)}
            className='react-select-container'
            classNamePrefix='react-select'
            placeholder=''
          />
          {errorMsg.missingtransferTo && (<p className='error-msg'>{errorMsg.missingtransferTo}</p>)}
          <label>סכום לתשלום </label>
          <input
            type='number'
            className='number-fields'
            placeholder=''
            value={amount || ''}
            onChange={(e) => setAmount(Number(e.target.value))}
          />
          {errorMsg.missingAmount && (<p className='error-msg'>{errorMsg.missingAmount}</p>)}
        </div>
      )}
      {
        popupProps.isOpen && (
          <Popup
            {...popupProps}
          />)
      }
      <PaymentTable users={users} setSelectedUsersId={setSelectedUsersId} />
      <button className='btn' onClick={handleUpdate} disabled={isLoading}>{paymentType === 'transfer' ? 'בצעו העברה' : 'בצעו חלוקה'}</button>

    </div>
  );
}

export default PaymentDashboard;